"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iFetchSuccessData = void 0;
const t = require("io-ts");
const TypesLib = require("@caddigital/sok-types");
exports.iFetchSuccessData = t.interface({
    node: TypesLib.File.iFolder,
    path: t.array(TypesLib.File.iFolder),
    files: t.array(TypesLib.File.iRevisionOrFolderSimplified),
    total: t.number
});
function default_1(namespace) {
    const FETCH_REQUEST = `@sok/modules/files/list/${namespace}/FETCH_REQUEST`;
    const FETCH_SUCCESS = `@sok/modules/files/list/${namespace}/FETCH_SUCCESS`;
    const FETCH_FAILURE = `@sok/modules/files/list/${namespace}/FETCH_FAILURE`;
    const CLEAR = `@sok/modules/files/list/${namespace}/CLEAR`;
    return {
        FETCH_REQUEST,
        FETCH_SUCCESS,
        FETCH_FAILURE,
        CLEAR
    };
}
exports.default = default_1;
//# sourceMappingURL=actionTypes.js.map